import { ErrorLogComponent } from '@cian/error-log-component';
import * as React from 'react';
import { Provider } from 'react-redux';
import { PageContainer } from '../PageContainer';
import { TReduxStore } from '../../types/redux';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { IApplicationContext as IAppContext } from '../../types/ICustomContextParams';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import { ApplicationContext } from '../../utils/applicationContext';

export interface IApplicationProps {
  reduxStore: TReduxStore;
  context: IAppContext;
}

export const Application: React.FC<React.PropsWithChildren<IApplicationProps>> = props => {
  const { reduxStore, context } = props;
  const {
    logger,
    custom: { userAgent },
  } = context;

  return (
    <ApplicationContext.Provider value={context}>
      <ErrorLogComponent logger={logger}>
        <UiKitContextProvider deviceType={uaToDeviceType(userAgent)}>
          <Provider store={reduxStore}>
            <PageContainer />
          </Provider>
        </UiKitContextProvider>
      </ErrorLogComponent>
    </ApplicationContext.Provider>
  );
};
